export enum TemplatePosition {
  beforebegin = 'beforebegin',
  afterbegin = 'afterbegin',
  beforeend = 'beforeend',
  afterend = 'afterend',
}

export const TemplatePositionDescriptions: { [key in TemplatePosition]: string } = {
  beforebegin: 'templatePositionDescription.beforebegin',
  afterbegin: 'templatePositionDescription.afterbegin',
  beforeend: 'templatePositionDescription.beforeend',
  afterend: 'templatePositionDescription.afterend',
};
